module.exports = __webpack_public_path__ + "img/Gallery_3_08.be8adff3.jpeg";